
import React from 'react';
import { useSelector } from 'react-redux';
import SecondaryNavbar from './Nav/SecondaryNavbar';
import Footer from './Footer/Footer';
import { Box } from '@mui/material';
import MiniDrawer from './Nav/Drawer';
import AppSnackbar from './AppSnackbar';
import {Alert, Button} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AuthenticatedLayout = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  const access = useSelector((s) => s.access);
  const subscriptionPlan = access?.subscriptionPlan || 'none';
  const showPastDueBanner = subscriptionPlan === 'PastDue';
  const navigate = useNavigate();

  const handleChangePaymentClick = () => {
    navigate('/subscribe?mode=change');
  };

  return (
    <>
      <SecondaryNavbar open={open} setOpen={setOpen} />
      <MiniDrawer open={open} setOpen={setOpen} />
      <AppSnackbar />

      {showPastDueBanner && (
      <Box sx={{ mb: 2, width:'100%', marginLeft:'auto', position:'fixed', zIndex:'10' }}>
        <Alert severity="error" sx={{width:'95%', marginLeft:'auto'}}
        action={
        <Button
          color="inherit"
          size="small"
          variant='outlined'
          sx={{ textTransform: 'capitalize', borderRadius: '999px' }}
          onClick={handleChangePaymentClick}
        >
          Change payment method
        </Button>
      }>
                We couldn’t charge your card. We’ll automatically retry your payment for several days. If it fails, your subscription will be
                cancelled.
        </Alert>
      </Box>
    )}

      <Box component="main" sx={{ p: 2, display:'flex', flexDirection: 'column',
        minHeight: '80vh'  }}>
        {children}
      </Box>
      <Footer />
    </>
  );
};

export default AuthenticatedLayout;
